import { Navigate, useLocation } from "react-router-dom";
import { useContactAuth } from "../../hooks/useContactAuthContext";

interface ProtectedContactRouteProps {
  children: JSX.Element;
}

export default function ProtectedContactRoute({
  children,
}: ProtectedContactRouteProps) {
  const { isContactAuthenticated } = useContactAuth();
  const location = useLocation();

  if (!isContactAuthenticated) {
    // Not logged in: redirect to /contact-login, and remember where we came from
    return <Navigate to="/contact/login" replace state={{ from: location }} />;
  }

  // Authorized → render the child component
  return children;
}
